/**
 * @file M08 Toplist Online Registration
 *
 * @author jonas.huber@notch-interactive.com
 */

/* Imports */
import eventList from '../components/event-list';

const instance = {},
    defaults = {
        hook: '[data-event-list]',
        boundAttr: 'data-event-list-bound'
    },
    settings = {};

let eventLists;

instance.init = (options) => {
    Object.assign(settings, defaults, options);

    eventLists = document.querySelectorAll(settings.hook + ':not([' + settings.boundAttr + '])');

    if (eventLists.length) {
        eventLists.forEach((el) => {
            eventList(el);

            // Set the bound Attribute, so that this module doesn't initiate the factory multiple times over the same elements
            el.setAttribute(settings.boundAttr, '');
        });
    }
};

export default instance;
